import { render, staticRenderFns } from "./TimeDiscountDetail.vue?vue&type=template&id=4b1ea29e&"
import script from "./TimeDiscountDetail.vue?vue&type=script&lang=js&"
export * from "./TimeDiscountDetail.vue?vue&type=script&lang=js&"
import style0 from "./TimeDiscountDetail.vue?vue&type=style&index=0&id=4b1ea29e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports